const getters = {
    quotations: (state) => state.quotations,
    quotationId: (state) => state.quotationId,
    newQuotation: (state) => state.newQuotation,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;